/**
 * @file Root route element: the app shell wrapped around the routed page.
 *
 * Mounts `NavigationGuard` once for the whole app — it renders `null`, so its
 * position in the tree is free — and hands the routed page to `AppShell`,
 * which owns the banner and the height invariant. The router's `errorElement`
 * replaces this element outright and mounts `AppShell` itself.
 */
import { Outlet } from 'react-router-dom';

import NavigationGuard from '../components/NavigationGuard';
import AppShell from './AppShell';

function RootLayout() {
  return (
    <>
      <NavigationGuard />
      <AppShell>
        <Outlet />
      </AppShell>
    </>
  );
}

export default RootLayout;
